import React, { useContext } from "react";
import ic_call from "../../assets/images/ic_call_green.svg";
import ic_location from "../../assets/images/ic_location_greenMedical.svg";
import ic_mail from "../../assets/images/ic_email_green.svg";
import DoctorSymbol from "../../assets/images/medical_symbol.svg";
import sign from "../../assets/images/sign.png";
import Modal from "react-bootstrap/Modal";
import { AppContext } from "../../context/AppContext";
import "./medicalPrescriptionComp.css"
import OrderTable from "./OrderTable/OrderTable";
const MedicalPrescriptionComp = ({orderDetails, orderStatusMap}) => {
  const { Prescription, setPrescription } = useContext(AppContext);

  return (
    <div className="prescription-wrapper-main ">
      <Modal
        show={Prescription}
        onHide={() => setPrescription(false)}
        size="lg"
        id="prescription-modal"
      >
        <div className="top-btns">
          <button>Submit</button>
        </div>
        <Modal.Body>
          <div className="orderModalInvoice zero-margin-paragraph-class" id="medical-prescription">
            <div className="modalHeading">
              {/* <div className="upperBlue">
                <h1 className="docName">Gayatri Medicals</h1>
                <label className="domainLab">Pharmacy</label>
                <label className="certificateLab">Certifcation 12548-20</label>
              </div>
              <div className="docSymbolBox">
                <img src={DoctorSymbol} className="docSymImg" alt="" />
              </div> */}
            </div>
            <div className="modalBody">
              <p className="heading-custom">Online Order Details</p>
   <div className="order-container row border rounded-3 mx-2">
      
      {/* Section 1 */}
      <div className="col-4 info-block my-2--">
        <p className="info-title">Order No:</p>
        <p className="info-value">{orderDetails?.order_id}</p>
      </div>

      <div className="col-4 info-block my-2--">
        <p className="info-title">Order From:</p>
        <p className="info-value">{orderDetails?.ondc_bap}</p>
      </div>

      <div className="col-4 info-block my-2--">
        <p className="info-title">Customer Name:</p>
        <p className="info-value">{orderDetails?.user_address?.user_name}</p>
      </div>

      <hr className="divider" />

      {/* Section 2 */}
      <div className="col-4 info-block my-2--">
        <p className="info-title">Customer Phone:</p>
        <p className="info-value">{orderDetails?.user_address?.user_phone_number}</p>
      </div>

      <div className="col-4 info-block my-2--">
        <p className="info-title">Customer Address:</p>
        <p className="info-value">
  {orderDetails?.user_address?.user_address}
        </p>
      </div>

      <div className="col-4 info-block my-2--">
        <p className="info-title">Number of Persons:</p>
        <p className="info-value">-</p>
      </div>

      <hr className="divider" />

      {/* Section 3 */}
      <div className="col-4 info-block my-2--">
        <p className="info-title">Order Type:</p>
        <p className="info-value">{orderDetails?.order_type === 'H' ? "Home Delivery" : orderDetails?.order_type === 'P' ? "Parcel" : '' }</p>
      </div>

      <div className="col-4 info-block my-2--">
        <p className="info-title">Payment Type:</p>
        <p className="info-value">{orderDetails?.payment_type}</p>
      </div>

      <div className="col-4 info-block my-2--">
        <p className="info-title">Order Status:</p>
        <p className="info-value"> {orderStatusMap[orderDetails.order_status] ||
                                    "Unknown Status"}{" "}</p>
      </div>

      <hr className="divider" />

      {/* Section 4 */}
      <div className="col-4 info-block my-2--">
        <p className="info-title">Restaurant:</p>
        <p className="info-value">
        {orderDetails?.restaurant_address?.restaurant_address}
        </p>
      </div>

      <hr className="divider" />

      {/* Section 5 */}
      <div className="col-4 info-block my-2--">
        <p className="info-title">Customer Notes:</p>
        <p className="info-value"></p>
      </div>
    </div>

  <p className="heading-custom mt-4">Online Order Items</p>

<OrderTable orderDetails={orderDetails} />


          
          
            </div>
           
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default MedicalPrescriptionComp;
